import { ProductStandardPrice, ProductPrice } from '@zooplus/ui-components';

type ItemStandardPriceProps = {
  isBonusArticle?: boolean;
  points?: number;
  formattedSubtotal?: string;
  isNewPricingEnabled?: boolean;
  isPreviewPage?: boolean;
};

const ItemStandardPrice = ({
  isBonusArticle,
  points,
  formattedSubtotal,
  isNewPricingEnabled,
  isPreviewPage,
}: ItemStandardPriceProps) => {
  return isNewPricingEnabled ? (
    <ProductPrice
      data-testid="article-quantity-subtotal"
      isPriceBold={!isPreviewPage}
      price={`${isBonusArticle ? points : formattedSubtotal}`}
    />
  ) : (
    <ProductStandardPrice
      data-testid="article-quantity-subtotal"
      price={`${isBonusArticle ? points : formattedSubtotal}`}
    />
  );
};

export default ItemStandardPrice;
